
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import CaseStudies from './components/CaseStudies';
import ContactPage from './ContactPage';
import './styles/globals.css';
import ScrollToTop from './ScrollToTop';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/portfolio" element={<CaseStudies />} />
          <Route path="/portfolio/:id" element={<CaseStudies />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;